import React, { Component } from "react";
import { Row, Col } from "react-flexbox-grid";
import Paper from "material-ui-next/Paper";
import Typography from "material-ui-next/Typography";
import {
  DatePicker,
  Loadable,
  SelectField,
  TextField
} from "components/support";
import Moment from "moment";

class SalessReportFilter extends Component {
  constructor(props) {
    super(props);

    this.state = {
      dateFrom: props.filters.dateFrom,
      dateTo: props.filters.dateTo,
      closeWorkaround: false
    };
  }

  static sReportTypes = [
    { value: "all", label: "Todos" },
    { value: "devolution", label: "Devoluções" },
    { value: "cfe", label: "CFe" },
    { value: "nfce", label: "NFCe" },
    { value: "receipt", label: "Recibo" },
    { value: "order", label: "Ordem" }
  ];

  static sSaleStatus = [
    { value: "all", label: "Todas as Vendas" },
    { value: "active", label: "Ativas" },
    { value: "cancelled", label: "Canceladas" },
    { value: "cancelled_order", label: "Pedidos Cancelados" },
    { value: "error", label: "Com erro" }
  ];

  static sOrderType = [
    { value: "all", label: "Todos" },
    { value: "IFOOD", label: "IFOOD" }
  ];

  handleField = ({ documentNumber, documentSerie }) => {
    const { onFilter } = this.props;
    const value = {};

    value.documentNumber = documentNumber;
    value.documentSerie = documentSerie;

    return onFilter(value);
  };

  handleChange = ({
    startDate,
    endDate,
    reportType,
    saleStatus,
    orderType
  }) => {
    const { onChange } = this.props;
    const options = {};

    if (startDate) {
      options.dateFrom = Moment(startDate);
    }

    if (endDate) {
      options.dateTo = Moment(endDate);
    }

    this.setState(options);

    if (reportType) {
      onChange({ reportType });
    }

    if (saleStatus) {
      onChange({ saleStatus });
    }

    if (orderType) {
      onChange({ orderType });
    }
  };

  handleClose = () => {
    const { onChange } = this.props;
    this.setState({ closeWorkaround: !this.state.closeWorkaround }, () => {
      onChange({
        dateFrom: this.state.dateFrom,
        dateTo: this.state.dateTo
      });
    });
  };

  render() {
    const { loading, filters } = this.props;
    const { dateFrom, dateTo } = this.state;
    const {
      reportType,
      saleStatus,
      documentNumber,
      documentSerie,
      orderType
    } = filters;

    return (
      <Paper elevation={1} className="p-sm mb-md">
        <Loadable loading={loading}>
          <Typography type="headline">Filtro</Typography>
          <Row>
            <Col xs={12} md={6}>
              <DatePicker
                multiple
                label="Período"
                modal
                fullWidth
                startDate={dateFrom}
                endDate={dateTo}
                onChange={({ startDate, endDate }) =>
                  this.handleChange({ startDate, endDate })
                }
                onClose={this.handleClose}
              />
            </Col>
            <Col xs={12} md={3}>
              <SelectField
                fullWidth
                options={SalessReportFilter.sSaleStatus}
                label="Status da Venda"
                value={saleStatus}
                onChange={(_, saleStatus) => this.handleChange({ saleStatus })}
              />
            </Col>
            <Col xs={12} md={3}>
              <SelectField
                fullWidth
                options={SalessReportFilter.sReportTypes}
                label="Tipo de Documento"
                value={reportType}
                onChange={(_, reportType) => this.handleChange({ reportType })}
              />
            </Col>
          </Row>
          <Row>
            <Col xs={12} lg={6}>
              <TextField
                fullWidth
                allowClear
                value={documentNumber}
                label="Número do Documento"
                onChange={(_, documentNumber) =>
                  this.handleField({ documentNumber })
                }
              />
            </Col>
            <Col xs={12} lg={3}>
              <TextField
                fullWidth
                allowClear
                value={documentSerie}
                label="Série do Documento"
                onChange={(_, documentSerie) =>
                  this.handleField({ documentSerie })
                }
              />
            </Col>
            <Col xs={12} md={3}>
              <SelectField
                fullWidth
                options={SalessReportFilter.sOrderType}
                label="Canal da Venda"
                value={orderType}
                onChange={(_, orderType) => this.handleChange({ orderType })}
              />
            </Col>
          </Row>
        </Loadable>
      </Paper>
    );
  }
}

export default SalessReportFilter;



// WEBPACK FOOTER //
// ./src/components/app/management/sales-report/filter/index.jsx